<div class="action-box-container">
  <div class="action-box" [class.disabled]="disabled">
    <div class="box-icon">
      <ng-content select="app-action-box-icon"></ng-content>
      <ng-content select="[action-box-icon]"></ng-content>
    </div>
    <div class="box-content">
      <ng-content select="app-action-box-content"></ng-content>
    </div>
    <div class="box-cta">
      <ng-content select="app-action-box-switch"></ng-content>
      <ng-content select="[action-box-cta]"></ng-content>
    </div>
  </div>
  <ng-content></ng-content>
</div>
